import { Navigate } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-auth";
import { hasWholesale } from "@/lib/roles";

export function WholesaleOnly({ children }: { children: React.ReactNode }) {
  const { user } = useSession();
  if (user && !hasWholesale(user)) return <Navigate to="/orders" />;
  return <>{children}</>;
}
